export enum QUALITY_SUITES_FE_BE_MAPPING_FIELD {
    id = 'id',
    type = 'type',
    companyName = 'companyName',
    name = 'name',
    SSOID = 'SSOID',
    email = 'email',
    business = 'business',
    qualitySuiteModule = 'qualitySuiteModule',
    supplierCountryCode = 'supplierCountryCode',
    supplierCity = 'supplierCity',
    zipCode = 'zipCode',
    GSLNumber = 'GSLNumber',
    vendorCode = 'vendorCode',
    supplierContactName = 'supplierContactName',
    supplierSSOID = 'supplierSSOID',
    supplierEmail = 'supplierEmail',
    access = 'access',
    siteCode = 'siteCode',
    SQEName = 'SQEName',
    jobTitle = 'jobTitle',
    phone = 'phone',
    extension = 'extension',
    scxID = 'scxID',
}

export class QualitySuites {
    id: number;
    type: string;
    companyName: string;
    name: string;
    SSOID: string;
    email: string;
    business: any;
    qualitySuiteModule: string;
    supplierCountryCode: string;
    supplierCity: string;
    // zipCode: string;
    GSLNumber: string;
    // vendorCode: string;
    // supplierContactName: string;
    // supplierSSOID: string;
    // supplierEmail: string;
    access: string;
    siteCode: string;
    SQEName: string;
    jobTitle: string;
    phone: string;
    extension: string;
    scxID: string;

    constructor(params: any = {}, parsed: boolean = true, SQEsso?) {
        if (parsed) {
            this.parseFromResp(params);
        } else {
            this.id = params.id;
            this.type = params.type;
            this.companyName = params.companyName;
            this.name = params.name;
            this.SSOID = params.SSOID;
            this.email = params.email;
            this.business = params.business;
            this.qualitySuiteModule = params.qualitySuiteModule;
            this.GSLNumber = params.GSLNumber;
            this.access = params.access;
            this.siteCode = params.siteCode;
            this.SQEName = SQEsso ? SQEsso : params.SQEName;
            this.scxID = params.scxID;
            this.jobTitle = params.jobTitle;
            this.phone = params.phone;
            this.extension = params.extension;
            this.supplierCountryCode = params.supplierCountryCode;
            this.supplierCity = params.supplierCity;
        }
    }

    parseFromResp(respObject: any = {}) {
        this.id = respObject[QUALITY_SUITES_FE_BE_MAPPING_FIELD.id];
        this.type = respObject[QUALITY_SUITES_FE_BE_MAPPING_FIELD.type];
        this.companyName = respObject[QUALITY_SUITES_FE_BE_MAPPING_FIELD.companyName];
        this.name = respObject[QUALITY_SUITES_FE_BE_MAPPING_FIELD.name];
        this.SSOID = respObject[QUALITY_SUITES_FE_BE_MAPPING_FIELD.SSOID];
        this.email = respObject[QUALITY_SUITES_FE_BE_MAPPING_FIELD.email];
        this.business = respObject[QUALITY_SUITES_FE_BE_MAPPING_FIELD.business];
        this.qualitySuiteModule = respObject[QUALITY_SUITES_FE_BE_MAPPING_FIELD.qualitySuiteModule];
        this.supplierCountryCode = respObject[QUALITY_SUITES_FE_BE_MAPPING_FIELD.supplierCountryCode];
        this.supplierCity = respObject[QUALITY_SUITES_FE_BE_MAPPING_FIELD.supplierCity];
        // this.zipCode = respObject[QUALITY_SUITES_FE_BE_MAPPING_FIELD.zipCode];
        this.GSLNumber = respObject[QUALITY_SUITES_FE_BE_MAPPING_FIELD.GSLNumber];
        // this.vendorCode = respObject[QUALITY_SUITES_FE_BE_MAPPING_FIELD.vendorCode];
        // this.supplierContactName = respObject[QUALITY_SUITES_FE_BE_MAPPING_FIELD.supplierContactName];
        // this.supplierSSOID = respObject[QUALITY_SUITES_FE_BE_MAPPING_FIELD.supplierSSOID];
        // this.supplierEmail = respObject[QUALITY_SUITES_FE_BE_MAPPING_FIELD.supplierEmail];
        this.access = respObject[QUALITY_SUITES_FE_BE_MAPPING_FIELD.access];
        this.siteCode = respObject[QUALITY_SUITES_FE_BE_MAPPING_FIELD.siteCode];
        this.SQEName = respObject[QUALITY_SUITES_FE_BE_MAPPING_FIELD.SQEName];
        this.jobTitle = respObject[QUALITY_SUITES_FE_BE_MAPPING_FIELD.jobTitle];
        this.phone = respObject[QUALITY_SUITES_FE_BE_MAPPING_FIELD.phone];
        this.extension = respObject[QUALITY_SUITES_FE_BE_MAPPING_FIELD.extension];
        this.scxID = respObject[QUALITY_SUITES_FE_BE_MAPPING_FIELD.scxID];
        return this;
    }

    convertToReqBody() {
        const body = {};
        body[QUALITY_SUITES_FE_BE_MAPPING_FIELD.id] = this.id;
        body[QUALITY_SUITES_FE_BE_MAPPING_FIELD.type] = this.type;
        body[QUALITY_SUITES_FE_BE_MAPPING_FIELD.companyName] = this.companyName;
        body[QUALITY_SUITES_FE_BE_MAPPING_FIELD.name] = this.name;
        body[QUALITY_SUITES_FE_BE_MAPPING_FIELD.SSOID] = this.SSOID;
        body[QUALITY_SUITES_FE_BE_MAPPING_FIELD.email] = this.email;
        body[QUALITY_SUITES_FE_BE_MAPPING_FIELD.business] = this.business.name;
        body[QUALITY_SUITES_FE_BE_MAPPING_FIELD.qualitySuiteModule] = this.qualitySuiteModule;
        body[QUALITY_SUITES_FE_BE_MAPPING_FIELD.supplierCountryCode] = this.supplierCountryCode;
        body[QUALITY_SUITES_FE_BE_MAPPING_FIELD.supplierCity] = this.supplierCity;
        // body[QUALITY_SUITES_FE_BE_MAPPING_FIELD.zipCode] = this.zipCode;
        body[QUALITY_SUITES_FE_BE_MAPPING_FIELD.GSLNumber] = this.GSLNumber;
        // body[QUALITY_SUITES_FE_BE_MAPPING_FIELD.vendorCode] = this.vendorCode;
        // body[QUALITY_SUITES_FE_BE_MAPPING_FIELD.supplierContactName] = this.supplierContactName;
        // body[QUALITY_SUITES_FE_BE_MAPPING_FIELD.supplierSSOID] = this.supplierSSOID;
        // body[QUALITY_SUITES_FE_BE_MAPPING_FIELD.supplierEmail] = this.supplierEmail;
        body[QUALITY_SUITES_FE_BE_MAPPING_FIELD.access] = this.access;
        body[QUALITY_SUITES_FE_BE_MAPPING_FIELD.siteCode] = this.siteCode;
        body[QUALITY_SUITES_FE_BE_MAPPING_FIELD.SQEName] = this.SQEName;
        body[QUALITY_SUITES_FE_BE_MAPPING_FIELD.jobTitle] = this.jobTitle;
        body[QUALITY_SUITES_FE_BE_MAPPING_FIELD.phone] = this.phone;
        body[QUALITY_SUITES_FE_BE_MAPPING_FIELD.extension] = this.extension;
        body[QUALITY_SUITES_FE_BE_MAPPING_FIELD.scxID] = this.scxID;
        return body;
    }
}
